<template>
  <div>
    <div class="homepage-striep-product-row">
        <h2>{{ title }}</h2>
    <div class="product-container">
      <div
        v-for="product in products"
        v-bind:class="category + ' striep-product-box' + ' ' + (product.isPromoPakket ? 'promopakket' : '')"
        :key="product.id"
      >
        <div class="square-box">
          <a class="square-content" :href="product.url">
            <template v-if="product.isPromoPakket">
              <img
                v-for="image in product.imageUrls"
                v-bind:class="'striep-product-box__image' + product.imageUrls.length"
                v-bind:src="image.imageUrl"
                :title="image.title"
                :alt="image.alternateText"
                :key="image.imageUrl"
              />
            </template>
            <img v-else v-bind:src="product.imageUrls[0].imageUrl" 
                :title="product.imageUrls[0].title"
                :alt="product.imageUrls[0].alternateText"
                :key="product.imageUrls[0].imageUrl" />
          </a>
        </div>

        <div class="striep-product-box-meta-data">
          <span class="striep-product-box-meta-data__title">
            <a v-bind:href="product.url">{{ product.title }}</a>
          </span>
          <div class="striep-product-box-meta-data__cover" v-if="product.cover">
              <span class="">{{ product.cover }}</span>
          </div>
          <div class="striep-product-box-meta-data__price">
            <span v-if="product.oldPrice" class="old-price">&euro; {{product.oldPrice}}</span>
            <span class="current-price">&euro;&nbsp;{{ product.price }}</span>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'url', 'category'],
  data: function () {
    return {
      products: []
    };
  },
  mounted() {
      this.fetchData();
    //   this.cat = this.category;
  },
  methods: {
    fetchData() {
      // http://localhost:8080/search/catalog?category=alle%20strips&sortField=number&sortOrder=desc
      fetch(this.url)
        .then((result) => result.json())
        .then((json) => {
          this.products = json.products;
        });
    }
  }
};
</script>

<style>
.hello {
  background-color: #ffe;
}
</style>